import { render, staticRenderFns } from "./DescriptionExtractor.vue?vue&type=template&id=e275b17a&scoped=true"
import script from "./DescriptionExtractor.vue?vue&type=script&lang=js"
export * from "./DescriptionExtractor.vue?vue&type=script&lang=js"
import style0 from "./DescriptionExtractor.vue?vue&type=style&index=0&id=e275b17a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e275b17a",
  null
  
)

export default component.exports